import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import CommonDialog from '../notificationOverlay/CommonDialog'
import ConnectedCalendarItem from './ConnectedCalendarItem'
import { Typography } from '@mui/material'
import LinkCalendarDialog from './LinkCalendarDialog'
import InCardStack from 'components/atoms/container/InCardStack'

const CalendarTokenInvalidPopup = ({
  oauthToken,
  refreshCallback = () => {}
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(oauthToken?.tokenInvalid)
  const [openCalendarDialog, setOpenCalendarDialog] = useState(false)
  const handleSigninCallback = () => {
    setOpenCalendarDialog(false)
    refreshCallback()
  }
  const handleDialogClose = reconnect => {
    setOpen(false)
    if (reconnect) {
      setOpenCalendarDialog(true)
    }
  }

  return (
    <>
      <CommonDialog
        open={open}
        setOpen={setOpen}
        titleText={t('calendarEvents.calendarConnectionNeeded')}
        notificationText={t(
          'calendarEvents.calendarConnectionNeededDesc.part1'
        )}
        onClose={handleDialogClose}
        showCloseButton={true}
        confirmText={t('calendarEvents.reconnect')}
        btnContainerProps={{
          sx: {
            justifyContent: 'center'
          }
        }}
        bodyWidth={420}>
        <Typography>
          <Trans
            i18nKey={'calendarEvents.calendarConnectionNeededDesc.part2'}
          />
        </Typography>
        {oauthToken?.data?.provider && (
          <InCardStack spacing={4}>
            <Typography>{t('calendarEvents.yourCalendar')}</Typography>
            <ConnectedCalendarItem
              provider={oauthToken.data.provider}
              email={oauthToken.data.email}
            />
          </InCardStack>
        )}
      </CommonDialog>
      <LinkCalendarDialog
        handleSigninResult={handleSigninCallback}
        dialogOpen={openCalendarDialog}
        setDialogOpen={setOpenCalendarDialog}
      />
    </>
  )
}

export default CalendarTokenInvalidPopup
